import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای لیست متریال‌ها

در این صفحه می‌توانید لیست تمامی مواد اولیه، نیمه‌ساخته‌ها و محصولات نهایی تعریف شده در سیستم را مدیریت کنید.

## ۱. جستجو و فیلتر
از طریق کادرهای جستجو می‌توانید متریال مدنظر خود را بر اساس نام، کد یا خانواده پیدا کنید.

## ۲. مشاهده جزئیات و نسخه‌ها
با کلیک روی هر متریال، لیست نسخه‌های (Revisions) آن نمایش داده می‌شود که در فرآیندهای تولید و انبار استفاده می‌گردند.

export default Layout;
